import { GET, POST, PUT, DELETE } from './api'

const table = "faqs"

export const ReadByUsage = async (usage, options = {}) => {
    const params = new URLSearchParams();

    if (options.locale) {
        params.set('locale', options.locale);
    }

    if (options.usageSlug) {
        params.set('usage_slug', options.usageSlug);
    }

    const queryString = params.toString();

    return await GET(`/faq/by-usage/${usage}${queryString ? `?${queryString}` : ''}`, true);
}

export const Create = async (params) => {
    return await POST(`/${ table }`, params, true);
}

export const Read = async () => {
    return await GET(`/${ table }?populate[items]=*`, true);
}

export const ReadOne = async (id) => {
    return await GET(`/${ table }/${id}?populate[items]=*`, true);
}

export const Update = async (params, id) => {
    return await PUT(`/${ table }/${id}`, params, true);
}

export const Delete = async (id) => {
    return await DELETE(`/${ table }/${ id }`, true);
} 
 
